import React from 'react';
import { Link } from 'react-scroll';
import './AboutUs.css';
import rightImg from '../../assets/motherboard-background.jpg'

const AboutUs = () => {
  return (
    <section className="aboutus" id="about">
      <div className="aboutus__container">
        <div className="aboutus__content">
          <div className="aboutus__text">
            <h2 className="aboutus__title">
              We create solutions for smarter businesses.
            </h2>
            <p className="aboutus__description">
            Belageri Technologies Pvt. Ltd. built by a team with deep software development experience in using customer listening to identify and implement business solutions for clients, our platform offers executives and assured path to proactively strengthen their business.
            </p>
            <div className="aboutus__buttons">
              <Link
                to="services"
                smooth={true}
                duration={500}
                offset={-70}
                className="aboutus__btn aboutus__btn--primary"
              >
                Our services →
              </Link>
              <Link
                to="workwithus"
                smooth={true}
                duration={500}
                offset={-70}
                className="aboutus__btn aboutus__btn--secondary"
              >
                Our solutions →
              </Link>
            </div>
          </div>
          <div className="aboutus__image">
            <img src={rightImg} alt="AI Energy Consumption Concept" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
